import Vue from 'vue'
import Router from 'vue-router'
import ROUTES from '@/router'
// import {ROUTER_DEFAULT_CONFIG} from '@/config/index'
import {routerBeforeEachFunc} from './interceptors/router'

// 解决同一路由非第一次点击的时候报错问题
const originalPush = Router.prototype.push
Router.prototype.push = function push(location) {
    return originalPush.call(this, location).catch(err => err)
}

Vue.use(Router)

// 注入默认配置和路由表
let routerInstance = new Router({
    // ...ROUTER_DEFAULT_CONFIG,
    mode: 'history',
    routes: ROUTES
})
// 注入拦截器
routerInstance.beforeEach(routerBeforeEachFunc)

export default routerInstance
